const vikaApiUrl = 'https://api.vika.cn/fusion/v1/datasheets/dsthSkoXLeKpGAS7rf/records?viewId=viwA2KineQSyp&fieldKey=id';
const vikaToken = 'usklHFiXEvUaSTLsyax7ZFS';

document.getElementById('testBtn').addEventListener('click', async () => {
  const resultEl = document.getElementById('result');
  resultEl.textContent = '加载中...';
  try {
    const response = await axios.get(vikaApiUrl, {
      headers: {
        'Authorization': `Bearer ${vikaToken}`,
        'Content-Type': 'application/json'
      }
    });
    resultEl.textContent = JSON.stringify(response.data, null, 2);
  } catch (error) {
    resultEl.textContent = '请求失败: ' + (error.response?.data || error.message);
  }
});